import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DocumentDownload } from 'iconsax-react';

const Consulenza = () => {

    const [showComingSoon, setShowComingSoon] = useState(false);

    return (
        <>
            <Modal className="fade" show={showComingSoon} centered onHide={() => setShowComingSoon(false)}>
                <Modal.Header>
                    <Modal.Title>Richiedi consulenza</Modal.Title>
                    <Button onClick={() => setShowComingSoon(false)} variant="" className="btn-close" />
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <h5>Coming Soon</h5>
                    <p className="text-muted mt-2">La prenotazione della consulenza sarà disponibile a breve.</p>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button className="btn btn-primary" onClick={() => setShowComingSoon(false)}>Chiudi</Button>
                </Modal.Footer>
            </Modal>

            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Consulenza</h4>
                        </div>
                        <div className="card-body">

                            <div className="row mb-4">
                                <div className="col-12">
                                    <h5 className="mb-2">Modello rendiconto per cassa ASD</h5>
                                    <p className="text-muted mb-3">
                                        Scarica il modello Excel per la compilazione del rendiconto per cassa della tua ASD.
                                    </p>
                                    <a
                                        href="/downloads/rendiconto-per-cassa-asd-modello-excel.xlsx"
                                        download
                                    >
                                        <Button variant="outline-primary">
                                            <DocumentDownload size="18" style={{ marginRight: '8px' }} />
                                            Scarica modello Excel
                                        </Button>
                                    </a>
                                </div>
                            </div>

                            <hr />

                            <div className="row mt-4">
                                <div className="col-12">
                                    <h5 className="mb-2">Prenota una consulenza</h5>
                                    <p className="text-muted mb-3">
                                        Richiedi una consulenza con il nostro commercialista. Scegli una data e un orario disponibile nel calendario.
                                    </p>
                                    <Button variant="primary" size="sm" className="sid-btn-compact" onClick={() => setShowComingSoon(true)}>
                        Richiedi consulenza
                    </Button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Consulenza;
